export const COVERAGE_MAP_PATH = "/home-health/coverage-map";
